import { render, staticRenderFns } from "./ColourAndExtras.vue?vue&type=template&id=56311d63&scoped=true&"
import script from "./ColourAndExtras.vue?vue&type=script&lang=js&"
export * from "./ColourAndExtras.vue?vue&type=script&lang=js&"
import style0 from "./ColourAndExtras.vue?vue&type=style&index=0&id=56311d63&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56311d63",
  null
  
)

export default component.exports